export class FrameScheduler {
  private pending: number | null = null;
  private disposed = false;

  constructor(private readonly render: (time: number) => boolean) {}

  request(): void {
    if (this.disposed || this.pending !== null) return;
    this.pending = requestAnimationFrame(time => {
      this.pending = null;
      if (!this.disposed && this.render(time)) this.request();
    });
  }

  stop(): void {
    if (this.pending !== null) cancelAnimationFrame(this.pending);
    this.pending = null;
  }

  dispose(): void { this.stop(); this.disposed = true; }
}
